import { ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import * as SPE from '@verybigthings/shader-particle-engine';
import { Color, Vector3 } from 'three';
export class FireModule extends ViewerModule {
    constructor() {
        super();
        this.particleGroups = [];
        this.particleEmitters = [];
        this.inited = false;
        console.log('FireModule constructor >>>>>>>>');
        Viewer.on('goToZSpace', () => {
            this.setZSpace(true);
        });
        Viewer.on('goFromZSpace', () => {
            this.setZSpace(false);
        });
    }
    init() {
        if (this.inited)
            return;
        this.inited = true;
        console.log('init FireModule:::::');
        const particleGroup = new SPE.Group({
            texture: {
                value: ResourcesManager.getTexture(`particle_fire`),
            },
            fog: false,
            colorize: true,
            blending: 1,
            transparent: true
        });
        const particleEmitter = new SPE.Emitter(this.getEmitterOptions());
        particleGroup.addEmitter(particleEmitter);
        this.addObject(particleGroup.mesh);
        this.particleGroups.push(particleGroup);
        this.particleEmitters.push(particleEmitter);
        this.uiObject.visible = true;
        Viewer.on('update', () => {
            this.particleGroups.forEach(el => el.tick(1 / 30));
        });
    }
    setZSpace(value) {
        console.log('setZSpace FIRE:');
        this.particleEmitters.forEach(emmiter => {
            console.log('FIRE:', emmiter);
            if (value)
                emmiter.size.value = [0.5 / 30, 0.5 / 30, 0.5 / 30, 0.5 / 30];
            else
                emmiter.size.value = [0.5, 0.5, 0.5, 0.5];
        });
    }
    getEmitterOptions() {
        // console.log('getEmitterOptions');
        return {
            particleCount: 300,
            maxAge: {
                value: 1.3,
                spread: 1
            },
            position: {
                value: new Vector3(0, 0, 0),
                spread: new Vector3(0.1, 0, 0),
                spreadClamp: new Vector3(0, 0, 0),
                distribution: SPE.distributions.Sphere,
                randomise: true
            },
            radius: {
                value: 0.5 / 10,
                spread: 0,
                scale: new Vector3(0.1, 0.1, 0.1),
                spreadClamp: new Vector3(0.2, 0.2, 0.2),
            },
            velocity: {
                value: new Vector3(0, 0.9, 0),
                spread: new Vector3(0.3, 0, 0.3),
                distribution: SPE.distributions.BOX,
                randomise: false
            },
            // acceleration: {
            //     value: new Vector3( 0, 0, 0 ),
            //     spread: new Vector3( 0, 0, 0 ),
            //     // distribution: SPE.distributions.BOX,
            //     randomise: false
            // },
            // drag: {
            //     value: 0.5,
            //     spread: 0
            // },
            // wiggle: {
            //     value: 0,
            //     spread: 0
            // },
            color: {
                value: [new Color(1, 0.5, 0), new Color(1, 0, 0)]
            },
            size: {
                // value: 0.5, // / (Viewer.controls.zController ? 1 : 1),
                value: 0.5 / (Viewer.controls.zController ? 30 : 1),
                spread: 0.1
                // spread: 0.1 / (Viewer.controls.zController ? 18 : 1)
                // value: 1.2 / 25,
                // spread: 0.8 / 18
            },
            opacity: {
                value: [1, 0]
            },
            angle: {
                value: 0,
                spread: 0
            }
        };
    }
}
